// ~/apps/themusicchurch-app/frontend/src/components/Common/ResponsiveBanner.jsx

import React from "react";
import styled from "styled-components";

// Full-width section that holds the background color
const BannerSection = styled.section`
  width: 100%;
  position: relative;
  isolation: isolate;
  padding: 56px 0;
  background-color: ${(props) => props.backgroundColor || props.theme.colors.homeNavy};
  background-image: url("/images/ministries/teal-nebula-photoreal-v1.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

`;

// Inner wrapper that constrains the content width
const BannerWrapper = styled.div`
  padding: clamp(12px, 2vw, 24px);
  width: 100%;
  max-width: ${(props) => props.maxWidth || "800px"};
  margin: 0 auto;

  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    max-width: 100%;
  }
`;

// The actual image element
const BannerImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
  border-radius: ${(props) => props.rounded && "8px"};
`;

const ResponsiveBanner = ({
  src,
  alt,
  maxWidth,
  rounded = false,
  backgroundColor,
}) => {
  return (
    <BannerSection backgroundColor={backgroundColor}>
      <BannerWrapper maxWidth={maxWidth}>
        <BannerImage src={src} alt={alt} rounded={rounded} />
      </BannerWrapper>
    </BannerSection>
  );
};

export default ResponsiveBanner;
